// Import icons (reuse from scans or add new ones)
/*
import ipDiscoveryIcon from "../../assets/images/HOSTSDISC_Dashboard.svg";
import dnsSecurityIcon from "../../assets/images/DNS_Dashboard.svg";
import danglingSubdomainsIcon from "../../assets/images/SUBDOM_Dashboard.svg";
import knownVulnRemediationIcon from "../../assets/images/VULNERAB_Dashboard.svg";
import sslRemediationIcon from "../../assets/images/SSLCERT_Dashboard.svg";
import webTechRemediationIcon from "../../assets/images/menu_icons/WebTechnologies_Dashboard.svg";
import brandMentionsRemediationIcon from "../../assets/images/menu_icons/BrandMentions_Dashboard.svg";
import fakeMobileAppsRemediationIcon from "../../assets/images/FAKEAPP_Dashboard.svg";
import lookAlikeDomainsRemediationIcon from "../../assets/images/image-gallery/Icon_1.svg";
import fakeSocialMediaRemediationIcon from "../../assets/images/FAKESME_Dashboard.svg";
import stolenCredentialsRemediationIcon from "../../assets/images/STOLENCRED_Dashboard.svg";
import malwareInfectedRemediationIcon from "../../assets/images/image-gallery/malware_infected_computers.svg";
import sourceCodeLeakageRemediationIcon from "../../assets/images/LEAKAGE_Dashboard.svg";
import leakedSessionsRemediationIcon from "../../assets/images/menu_icons/LeakedSession_Dashboard.svg";
import openCloudBucketsRemediationIcon from "../../assets/images/menu_icons/OpenCloudBuckets_Dashboard.svg";
import ipBlacklistsRemediationIcon from "../../assets/images/BLACKIP_Dashboard.svg";
import personalInfoRemediationIcon from "../../assets/images/menu_icons/PIL_Dashboard.svg";
*/

import ipDiscoveryIcon from "../../../assets/images/Identify_Valkyrie.svg";
import dnsSecurityIcon from "../../../assets/images/Identify_Valkyrie.svg";
import subdomainHealthIcon from "../../../assets/images/Identify_Valkyrie.svg";
import knownVulnRemediationIcon from "../../../assets/images/Identify_Valkyrie.svg";
import sslRemediationIcon from "../../../assets/images/Identify_Valkyrie.svg";
import webTechRemediationIcon from "../../../assets/images/Identify_Valkyrie.svg";
import brandMentionsRemediationIcon from "../../../assets/images/Identify_Valkyrie.svg";
import fakeMobileAppsRemediationIcon from "../../../assets/images/Identify_Valkyrie.svg";
import lookAlikeDomainsRemediationIcon from "../../../assets/images/Identify_Valkyrie.svg";
import fakeSocialMediaRemediationIcon from "../../../assets/images/Identify_Valkyrie.svg";
import stolenCredentialsRemediationIcon from "../../../assets/images/Identify_Valkyrie.svg";
import malwareInfectedRemediationIcon from "../../../assets/images/Identify_Valkyrie.svg";
import sourceCodeLeakageRemediationIcon from "../../../assets/images/Identify_Valkyrie.svg";
import leakedSessionsRemediationIcon from "../../../assets/images/Identify_Valkyrie.svg";
import openCloudBucketsRemediationIcon from "../../../assets/images/Identify_Valkyrie.svg";
import ipBlacklistsRemediationIcon from "../../../assets/images/Identify_Valkyrie.svg";
import personalInfoRemediationIcon from "../../../assets/images/Identify_Valkyrie.svg";



export const remediationSubcategories = [
  {
    id: "ip-discovery-open-ports",
    title: "IP Discovery & Open Ports",
    icon: ipDiscoveryIcon
  },
  {
    id: "dns-email-security",
    title: "DNS & Email Security",
    icon: dnsSecurityIcon
  },
  {
    id: "subdomain-health",
    title: "Subdomain Health",
    icon: subdomainHealthIcon
  },
  {
    id: "known-vulnerabilities",
    title: "Known Vulnerabilities",
    icon: knownVulnRemediationIcon
  },
  {
    id: "vulnerable-ssl-certificates",
    title: "Vulnerable SSL Certificates",
    icon: sslRemediationIcon
  },
  {
    id: "vulnerable-web-technologies",
    title: "Vulnerable Web Technologies",
    icon: webTechRemediationIcon
  },
  {
    id: "brand-mentions",
    title: "Brand Mentions",
    icon: brandMentionsRemediationIcon
  },
  {
    id: "fake-mobile-applications",
    title: "Fake Mobile Applications",
    icon: fakeMobileAppsRemediationIcon
  },
  {
    id: "lookalike-domains",
    title: "Lookalike Domains",
    icon: lookAlikeDomainsRemediationIcon
  },
  {
    id: "fake-social-media-profiles",
    title: "Fake Social Media Profiles",
    icon: fakeSocialMediaRemediationIcon
  },
  {
    id: "stolen-credentials",
    title: "Stolen Credentials",
    icon: stolenCredentialsRemediationIcon
  },
  {
    id: "malware-infected-computers",
    title: "Malware Infected Computers",
    icon: malwareInfectedRemediationIcon
  },
  {
    id: "source-code-leakage",
    title: "Source Code Leakage",
    icon: sourceCodeLeakageRemediationIcon
  },
  {
    id: "leaked-sessions",
    title: "Leaked Sessions",
    icon: leakedSessionsRemediationIcon
  },
  {
    id: "open-cloud-buckets",
    title: "Open Cloud Buckets",
    icon: openCloudBucketsRemediationIcon
  },
  {
    id: "blacklisted-ips",
    title: "Blacklisted IPs",
    icon: ipBlacklistsRemediationIcon
  },
  {
    id: "personal-information-leakage",
    title: "Personal Information Leakage",
    icon: personalInfoRemediationIcon
  }
];